var SeparableConvParams = /** @class */ (function () {
    function SeparableConvParams(depthwise_filter, pointwise_filter, bias) {
        this.depthwise_filter = depthwise_filter;
        this.pointwise_filter = pointwise_filter;
        this.bias = bias;
    }
    return SeparableConvParams;
}());
export { SeparableConvParams };
//# sourceMappingURL=types.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/face-api.js/build/es6/common/types.js
// module id = 1051
// module chunks = 0